import React, { PropTypes } from 'react'

import * as icons from 'icons'

import styles from './CardHeader.scss'
import Heading from 'components/Heading'
import classnames from 'classnames'

const createIcon = (Icon, key) => {
  return <Icon height="60" key={key} width="60" />
}

const CardHeader = ({ title, titleIcons, narrowPadding }) => {
  const classes = {
    [styles.narrowPadding]: narrowPadding,
  }
  return (
    <div className={classnames(styles.cardHeader, classes)}>
      <Heading className={styles.title}>{title}</Heading>
      {titleIcons && <div className={styles.icons}>
        {titleIcons.map((icon, i) => {
        return createIcon(icons[icon], i)
      })}
      </div>}
    </div>
  )
}

CardHeader.propTypes = {
  narrowPadding: PropTypes.bool,
  title: PropTypes.string.isRequired,
  titleIcons: PropTypes.array,
}

CardHeader.defaultProps = {
  narrowPadding: false,
  title: '',
}

export default CardHeader



// WEBPACK FOOTER //
// ./src/components/CardHeader/CardHeader.js